var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LoadingFull open"},[_c('div',{staticClass:"logo-image-container"},[_c('div',{staticClass:"logo first"}),_c('div',{staticClass:"logo second"}),_c('div',{staticClass:"logo third"}),_c('div',{staticClass:"logo fourth"})])])
}]

export { render, staticRenderFns }